import { render, staticRenderFns } from "./Soaps.vue?vue&type=template&id=21023aee&scoped=true&"
import script from "./Soaps.vue?vue&type=script&lang=js&"
export * from "./Soaps.vue?vue&type=script&lang=js&"
import style0 from "./Soaps.vue?vue&type=style&index=0&id=21023aee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21023aee",
  null
  
)

export default component.exports